import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Col, Row } from 'antd';

export function PasswordRecoveryForm() {
  const navigate = useNavigate();

  return (
    <Row justify="center">
      <Col md={16} sm={24}>
        <Card title="Esqueci minha senha">
          <Card.Meta description="Para sua segurança, a redefinição de senha não é feita por e-mail. Compareça à loja com um documento de identificação em mãos para que um administrador possa redefinir sua senha." />

          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
            <Col span={24}>
              <Button onClick={() => navigate('/login')} block type="primary">
                Voltar ao login
              </Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
